module.exports = __webpack_public_path__ + "static/media/info-icon.046de7b6.webp";